var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("purchase-item-view-controller", {
    attrs: { group: this.$props.group, id: this.$props.id },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (pivc) {
          return [
            _c(
              "div",
              {
                staticClass: "atmo-hash-jump-point",
                attrs: { id: "atmo-top" },
              },
              [
                _c("FastAccessMenu.view", {
                  attrs: { pivc: pivc, purchaseitem: pivc.purchaseitem },
                }),
                _c(
                  "section",
                  { staticClass: "atmo-page-banner-wrapper atmo-slim" },
                  [
                    _c("div", { staticClass: "atmo-container-fixed" }, [
                      _c("h2", [
                        _c("span", [_vm._v("№ ")]),
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              pivc.purchaseitem.registration_number
                            ),
                          },
                        }),
                      ]),
                      _c(
                        "ul",
                        {
                          staticClass:
                            "atmo-content-block-2-columns atmo-no-item-separator atmo-in-banner",
                        },
                        [
                          _c("li", [
                            _c("dt", [_vm._v("Статус закупки:")]),
                            _c("dd", {
                              staticClass:
                                "atmo-placeholder-animated atmo-inverse",
                              domProps: {
                                textContent: _vm._s(
                                  pivc.purchaseitem.status_title
                                ),
                              },
                            }),
                          ]),
                          _c("li", [
                            _c("dt", [_vm._v("Заказчик:")]),
                            _c("dd", {
                              staticClass:
                                "atmo-placeholder-animated atmo-inverse",
                              domProps: {
                                textContent: _vm._s(
                                  pivc.purchaseitem.customer.title
                                ),
                              },
                            }),
                          ]),
                          pivc.hasSupplier
                            ? _c("li", [
                                _c("dt", [_vm._v("Поставщик:")]),
                                _c("dd", {
                                  staticClass:
                                    "atmo-placeholder-animated atmo-inverse",
                                  domProps: {
                                    textContent: _vm._s(
                                      pivc.purchaseitem.supplier.title
                                    ),
                                  },
                                }),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "atmo-container-fixed atmo-page-content" },
                  [
                    _c("CustomerInfo.view", {
                      attrs: { purchaseitem: pivc.purchaseitem },
                    }),
                    _c("PurchaseTerms.view", {
                      attrs: { pivc: pivc, purchaseitem: pivc.purchaseitem },
                    }),
                    !pivc.isPurchaseOutATMO
                      ? _c("SupplierRequirements.view", {
                          attrs: {
                            requirements:
                              pivc.purchaseitem.supplier_requirements,
                            purchase: pivc.purchaseitem,
                          },
                        })
                      : _vm._e(),
                    !pivc.isPurchaseOutATMO
                      ? _c("SupplyTerms.view", {
                          attrs: { purchaseitem: pivc.purchaseitem },
                        })
                      : _vm._e(),
                    _c(
                      "DeliverablesList.view",
                      {
                        staticClass: "atmo-hash-jump-point",
                        attrs: {
                          origin: "notice",
                          deliverables: pivc.purchaseitem.deliverables,
                          id: "atmo-notice-deliverables",
                        },
                      },
                      [
                        !pivc.isPurchaseOutATMO
                          ? _c("span", [_vm._v("извещения")])
                          : _vm._e(),
                      ]
                    ),
                    pivc.features.kbk_limits &&
                    pivc.isUserEngagedCustomer &&
                    !pivc.purchaseitem.without_limits
                      ? _c("KBKLimitsList.view", {
                          attrs: { limits: pivc.purchaseitem.kbklimits },
                        })
                      : _vm._e(),
                    _c(
                      "AccordionItem",
                      {
                        staticClass: "atmo-hash-jump-point",
                        attrs: {
                          visible: _vm.$route.hash === "#explanation-requests",
                          title: "Запросы разъяснений по закупке",
                          id: "explanation-requests",
                        },
                      },
                      [
                        !!pivc.purchaseitem.id
                          ? _c("ExplanationRequestList", {
                              attrs: {
                                "purchase-item": pivc.purchaseitem,
                                "purchase-type": "fl44",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    !pivc.purchaseitem.hide_proposals_block
                      ? _c("ProposalsList.view", {
                          attrs: {
                            pivc: pivc,
                            proposals: pivc.purchaseitem.proposals,
                            purchaseitem: pivc.purchaseitem,
                          },
                        })
                      : _vm._e(),
                    pivc.isUserEngagedCustomer && pivc.isPurchaseSummarizing
                      ? _c("ProtocolSummarizationWidget.view", {
                          attrs: {
                            proposals: pivc.purchaseitem.proposals,
                            purchaseitem: pivc.purchaseitem,
                          },
                        })
                      : _vm._e(),
                    pivc.isPurchaseSummarized ||
                    pivc.hasContract ||
                    pivc.hasPurchaseProtocol
                      ? _c("SupplierInfo.view", {
                          attrs: {
                            pivc: pivc,
                            purchaseitem: pivc.purchaseitem,
                            supplier: pivc.purchaseitem.supplier,
                          },
                        })
                      : _vm._e(),
                    (pivc.isPurchaseSummarized ||
                      pivc.hasContract ||
                      pivc.hasPurchaseProtocol) &&
                    !pivc.isPurchaseOutATMO
                      ? _c("PriceBreakdown.view", {
                          attrs: { pricebreakdown: pivc.pricebreakdown },
                        })
                      : _vm._e(),
                    pivc.isPurchaseSummarized && !pivc.hasContract
                      ? _c(
                          "DeliverablesListWithVat.view",
                          {
                            attrs: {
                              origin: "notice",
                              islimitvisible: pivc.isUserEngagedCustomer,
                              deliverables: pivc.acceptedProposal.deliverables,
                              "offer-cost": pivc.acceptedProposal.offer_cost,
                              "price-wo-vat":
                                pivc.acceptedProposal.price_wo_vat,
                            },
                          },
                          [
                            !pivc.isPurchaseOutATMO
                              ? _c("span", [_vm._v("принятого предложения")])
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                    pivc.hasContract
                      ? _c("ContractDetails.view", {
                          attrs: {
                            pivc: pivc,
                            purchaseitem: pivc.purchaseitem,
                          },
                        })
                      : _vm._e(),
                    pivc.hasContract && !pivc.isPurchaseOutATMO
                      ? _c(
                          "DeliverablesListWithVat.view",
                          {
                            attrs: {
                              origin: "contract",
                              islimitvisible: false,
                              deliverables:
                                pivc.purchaseitem.contract.deliverables,
                              "offer-cost":
                                pivc.purchaseitem.contract.offer_cost,
                              "price-wo-vat":
                                pivc.purchaseitem.contract.price_wo_vat,
                            },
                          },
                          [
                            !pivc.isPurchaseOutATMO
                              ? _c("span", [_vm._v("контракта")])
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                    pivc.features.kbk_limits &&
                    pivc.isUserEngagedCustomer &&
                    !pivc.purchaseitem.without_limits &&
                    pivc.hasContract &&
                    !pivc.isPurchaseOutATMO
                      ? _c("KBKLimitsList.view", {
                          attrs: {
                            limits: pivc.purchaseitem.contract.kbk_limits,
                          },
                        })
                      : _vm._e(),
                    !pivc.purchaseitem.without_limits &&
                    pivc.features.kbk_limits &&
                    pivc.hasContract &&
                    pivc.isUserEngagedCustomer &&
                    !pivc.isContractSignedByCustomer &&
                    pivc.isContractSignedBySupplier &&
                    pivc.mustCustomerSignContract
                      ? _c("KBKLimitsEditableList.view", {
                          attrs: {
                            initiallist: pivc.purchaseitem.contract.kbk_limits,
                            totalamount:
                              pivc.purchaseitem.contract
                                .deliverables_total_amount,
                            limitfilterpresets: {
                              year: pivc.purchaseitem.limit_year,
                              purchase_type_id: pivc.purchaseitem.type_id,
                              purchase_id: pivc.purchaseitem.id,
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function () {
                                  return [_c("h5", [_vm._v("Измените лимиты")])]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    !pivc.purchaseitem.without_limits &&
                    pivc.features.kbk_limits &&
                    pivc.isContractActive &&
                    pivc.isUserEngagedCustomer &&
                    pivc.areContractLimitsEditable
                      ? _c("KBKLimitsAutonomousUpdateWidget.view", {
                          attrs: {
                            purchaseid: pivc.purchaseitem.id,
                            entity: pivc.purchaseitem.contract,
                            limitfilterpresets: {
                              year: pivc.purchaseitem.limit_year,
                              purchase_type_id: pivc.purchaseitem.type_id,
                              purchase_id: pivc.purchaseitem.id,
                            },
                          },
                        })
                      : _vm._e(),
                    pivc.isUserEngagedCustomer &&
                    pivc.purchaseitem.status_id ===
                      _vm.PurchaseStatuses.Summarized &&
                    pivc.purchaseitem.is_first_contract === null &&
                    !pivc.isContractSignedByCustomer
                      ? _c("editable-file-attachments-list-controller", {
                          attrs: { isrequired: true, maxfilesallowed: 1 },
                          on: {
                            "fileattachment:changed":
                              pivc.handleContractAttachment,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (efalc) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "atmo-component-wrapper",
                                        attrs: { id: "atmo-contract" },
                                      },
                                      [
                                        _c(
                                          "EditableFileAttachmentsList.view",
                                          {
                                            attrs: { controller: efalc },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "controls",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "ul",
                                                        {
                                                          staticClass:
                                                            "atmo-buttons",
                                                        },
                                                        [
                                                          _c(
                                                            "li",
                                                            {
                                                              attrs: {
                                                                disabled:
                                                                  !pivc.gotContractAttached,
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "ProgressIndicatingButton.component",
                                                                {
                                                                  attrs: {
                                                                    clickhandler:
                                                                      pivc.storeContract,
                                                                    text: "Отправить контракт",
                                                                    disabledstate:
                                                                      !_vm
                                                                        .$store
                                                                        .getters
                                                                        .getCanSign,
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "li",
                                                            [
                                                              _c(
                                                                "fl44-decline-contract-send-button",
                                                                {
                                                                  attrs: {
                                                                    "purchase-item":
                                                                      pivc.purchaseitem,
                                                                  },
                                                                  on: {
                                                                    refresh:
                                                                      _vm.refresh,
                                                                  },
                                                                }
                                                              ),
                                                              !_vm.$store
                                                                .getters
                                                                .getCanSign
                                                                ? [
                                                                    _vm.$store
                                                                      .getters
                                                                      .getLoginType ===
                                                                    "cert"
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "text-danger pl-3 pt-0 fs-14 w-50 my-auto",
                                                                            staticStyle:
                                                                              {
                                                                                "text-transform":
                                                                                  "initial",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              " Для действия требуется загрузить/заменить МЧД на странице: "
                                                                            ),
                                                                            _c(
                                                                              "router-link",
                                                                              {
                                                                                staticClass:
                                                                                  "green-link",
                                                                                attrs:
                                                                                  {
                                                                                    to: {
                                                                                      name: "CabinetUserProfile",
                                                                                    },
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "Данные учетной записи"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          1
                                                                        )
                                                                      : _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "text-danger pl-3 pt-0 fs-14 w-50 my-auto",
                                                                            staticStyle:
                                                                              {
                                                                                "text-transform":
                                                                                  "initial",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "Отправка контракта возможна только при авторизации при помощи ЭЦП"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                  ]
                                                                : _vm._e(),
                                                            ],
                                                            2
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c("span", [
                                              _c("h3", [_vm._v("Контракт")]),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    pivc.purchaseitem.contract.supplier_accounting &&
                    !pivc.purchaseitem.without_limits &&
                    pivc.features.kbk_limits &&
                    pivc.hasContract &&
                    pivc.isUserEngagedCustomer &&
                    pivc.isContractSignedByCustomer &&
                    pivc.isContractSignedBySupplier
                      ? _c(
                          "ContractSupplierAccountingInfo.view",
                          {
                            attrs: {
                              "supplier-accounting":
                                pivc.purchaseitem.contract.supplier_accounting,
                            },
                          },
                          [
                            _c("span", [
                              _vm._v("Банковские реквизиты поставщика"),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    !pivc.purchaseitem.without_limits &&
                    pivc.features.kbk_limits &&
                    pivc.hasContract &&
                    pivc.isUserEngagedCustomer &&
                    !pivc.isContractSignedByCustomer &&
                    pivc.isContractSignedBySupplier &&
                    pivc.mustCustomerSignContract
                      ? _c(
                          "ContractSupplierAccounting.view",
                          {
                            attrs: {
                              "initial-data":
                                pivc.purchaseitem.contract.supplier_accounting,
                            },
                            on: { select: pivc.supplierAccountingUpdated },
                          },
                          [
                            _c("span", [
                              _vm._v("Банковские реквизиты поставщика"),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    pivc.hasContract
                      ? _c(
                          "ContractAttachments.view",
                          {
                            attrs: {
                              pivc: pivc,
                              signatures: pivc.purchaseitem.contract.signatures,
                              attachments: pivc.contractAttachments.main,
                            },
                            scopedSlots: _vm._u(
                              [
                                (pivc.mustSupplierSignContract ||
                                  pivc.mustCustomerSignContract) &&
                                !pivc.isContractDisputed
                                  ? {
                                      key: "controls",
                                      fn: function () {
                                        return [
                                          pivc.purchaseitem
                                            .is_first_contract === false
                                            ? [
                                                pivc.purchaseitem
                                                  .second_contract_supplier_money
                                                  .status &&
                                                pivc.isUserEngagedSupplier
                                                  ? [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "atmo-button mr-2",
                                                          attrs: {
                                                            id: "contract-not-enough",
                                                            disabled:
                                                              (pivc.features
                                                                .kbk_limits &&
                                                                pivc.hasContractErrors) ||
                                                              !_vm.$store
                                                                .getters
                                                                .getCanSign,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Подписать и отправить контракт"
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "b-popover",
                                                        {
                                                          attrs: {
                                                            target:
                                                              "contract-not-enough",
                                                            triggers: "hover",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "fs-12 my-1 py-1",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Необходимо для блокировки "
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "fw-600 text-nowrap",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$formatPrice(
                                                                        pivc
                                                                          .purchaseitem
                                                                          .plain
                                                                          .fee_amount
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" руб. "),
                                                              _c("br"),
                                                              _vm._v(
                                                                " Для подписания контракта не хватает "
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "text-danger fw-600 text-nowrap",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$formatPrice(
                                                                        pivc
                                                                          .purchaseitem
                                                                          .second_contract_supplier_money
                                                                          .not_enough
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" руб."),
                                                              _c("br"),
                                                              _c(
                                                                "router-link",
                                                                {
                                                                  staticClass:
                                                                    "system_link-style",
                                                                  attrs: {
                                                                    to: {
                                                                      name: "CabinetAccounting",
                                                                    },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Пополнить лицевой счет"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" . "),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  : [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "atmo-button mr-2",
                                                          attrs: {
                                                            id: "sign-contract-button",
                                                            disabled:
                                                              (pivc.features
                                                                .kbk_limits &&
                                                                pivc.hasContractErrors) ||
                                                              !_vm.$store
                                                                .getters
                                                                .getCanSign,
                                                          },
                                                          on: {
                                                            click:
                                                              pivc.invokeSignContractPopup,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Подписать и отправить контракт"
                                                          ),
                                                        ]
                                                      ),
                                                      pivc.isUserEngagedSupplier
                                                        ? _c(
                                                            "b-popover",
                                                            {
                                                              attrs: {
                                                                target:
                                                                  "sign-contract-button",
                                                                triggers:
                                                                  "hover",
                                                                placement:
                                                                  "top",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "fs-12 my-1 py-1",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-danger",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "b-icon-exclamation-triangle-fill"
                                                                      ),
                                                                      _vm._v(
                                                                        " Внимание!"
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _c("br"),
                                                                  _vm._v(
                                                                    " На лицевом счете Вашей организации, в соответствии с Регламентом, будет заблокирована сумма "
                                                                  ),
                                                                  _c("strong", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$formatPrice(
                                                                          pivc
                                                                            .purchaseitem
                                                                            .plain
                                                                            .fee_amount
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]),
                                                                  _vm._v(
                                                                    " руб. "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ],
                                              ]
                                            : [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "atmo-button mr-2",
                                                    attrs: {
                                                      disabled:
                                                        (pivc.features
                                                          .kbk_limits &&
                                                          pivc.hasContractErrors) ||
                                                        !_vm.$store.getters
                                                          .getCanSign,
                                                    },
                                                    on: {
                                                      click:
                                                        pivc.invokeSignContractPopup,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Подписать и отправить контракт"
                                                    ),
                                                  ]
                                                ),
                                              ],
                                          pivc.mustSupplierSignContract ||
                                          pivc.mustCustomerSignContract
                                            ? _c(
                                                "fl44-decline-contract-sign-button",
                                                {
                                                  attrs: {
                                                    "purchase-item":
                                                      pivc.purchaseitem,
                                                  },
                                                  on: { refresh: _vm.refresh },
                                                }
                                              )
                                            : _vm._e(),
                                          !_vm.$store.getters.getCanSign
                                            ? [
                                                _vm.$store.getters
                                                  .getLoginType === "cert"
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger pl-3 pt-0 fs-14 w-50 my-auto",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Для действия требуется загрузить/заменить МЧД на странице: "
                                                        ),
                                                        _c(
                                                          "router-link",
                                                          {
                                                            staticClass:
                                                              "green-link",
                                                            attrs: {
                                                              to: {
                                                                name: "CabinetUserProfile",
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Данные учетной записи"
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger pl-3 pt-0 fs-14 w-50 my-auto",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Подписание возможно только при авторизации при помощи ЭЦП"
                                                        ),
                                                      ]
                                                    ),
                                              ]
                                            : _vm._e(),
                                        ]
                                      },
                                      proxy: true,
                                    }
                                  : null,
                              ],
                              null,
                              true
                            ),
                          },
                          [_c("span", [_vm._v("Основной контракт")])]
                        )
                      : _vm._e(),
                    pivc.hasContract && pivc.isPurchaseOutATMO
                      ? _c(
                          "ContractAttachments.view",
                          {
                            attrs: {
                              pivc: pivc,
                              signatures: {},
                              attachments:
                                pivc.contractAttachments.confirmation,
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                "Подтверждающие документы (акт, накладная, УПД)"
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    pivc.hasContract && pivc.hasDisputes
                      ? _c("ContractDisputes.view", {
                          attrs: {
                            pivc: pivc,
                            disputes: pivc.purchaseitem.contract.disputes,
                          },
                        })
                      : _vm._e(),
                    ((pivc.isUserEngagedCustomer && pivc.isContractDisputed) ||
                      (pivc.isContractProposed &&
                        pivc.isUserEngagedSupplier &&
                        pivc.canSupplierSubmitDisputes)) &&
                    pivc.isPurchaseSummarized
                      ? _c("ContractDisputesResolutionWidget.view", {
                          attrs: { pivc: pivc },
                          on: { refresh: _vm.refresh },
                        })
                      : _vm._e(),
                    pivc.purchaseitem.plain
                      ? _c("fl44-contract-supplementary-agreements-block", {
                          staticClass:
                            "atmo-hash-jump-point atmo-content-group",
                          attrs: {
                            purchase: pivc.purchaseitem.plain,
                            pivc: pivc,
                            id: "atmo-contract-annexes",
                          },
                          on: { refresh: _vm.refresh },
                        })
                      : _vm._e(),
                    !pivc.isUserEngagedCustomer && pivc.hasContract
                      ? _c("ContractFulfillment.view", {
                          attrs: {
                            pivc: pivc,
                            attachments:
                              pivc.purchaseitem.contract
                                .fulfillment_attachments,
                          },
                        })
                      : _vm._e(),
                    pivc.isUserEngagedCustomer &&
                    pivc.hasContract &&
                    pivc.isContractSignedByBoth
                      ? _c(
                          "editable-contract-fulfillment-file-attachments-list-controller",
                          {
                            attrs: {
                              contractid: pivc.purchaseitem.contract.id,
                              initiallist:
                                pivc.purchaseitem.contract
                                  .fulfillment_attachments,
                              origin: "fulfillment",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (efalc) {
                                    return [
                                      _c(
                                        "EditableFileAttachmentsList.view",
                                        { attrs: { controller: efalc } },
                                        [
                                          [
                                            _c(
                                              "h3",
                                              {
                                                staticClass:
                                                  "atmo-hash-jump-point atmo-content-group",
                                                attrs: {
                                                  id: "atmo-contract-fulfillment",
                                                },
                                              },
                                              [_vm._v("Исполнение контракта")]
                                            ),
                                            pivc.hasContract &&
                                            pivc.isUserEngagedCustomer &&
                                            pivc.isContractSignedByBoth
                                              ? _c(
                                                  "PurchaseStatusUpdateWidget.view",
                                                  {
                                                    attrs: {
                                                      contractid:
                                                        pivc.purchaseitem
                                                          .contract.id,
                                                      contractstatuses:
                                                        pivc.contractStatuses,
                                                      status: pivc.status,
                                                    },
                                                  }
                                                )
                                              : _vm._e(),
                                            _c("h5", [
                                              _vm._v("Документы об исполнении"),
                                            ]),
                                          ],
                                        ],
                                        2
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }
                        )
                      : _vm._e(),
                    !pivc.isPurchaseOutATMO
                      ? _c("ul", { staticClass: "atmo-buttons" }, [
                          _c(
                            "li",
                            [
                              _c("ProgressIndicatingButton.component", {
                                attrs: {
                                  type: "dimmed",
                                  clickhandler: pivc.downloadPurchaseInfo,
                                  text: "Скачать извещение",
                                },
                              }),
                            ],
                            1
                          ),
                          pivc.isPurchaseSummarized ||
                          pivc.isPurchaseFailed ||
                          pivc.hasContract ||
                          pivc.hasPurchaseProtocol
                            ? _c(
                                "li",
                                [
                                  _c("ProgressIndicatingButton.component", {
                                    attrs: {
                                      type: "dimmed",
                                      clickhandler: pivc.downloadProtocol,
                                      text: "Скачать итоговый протокол",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          pivc.hasContract
                            ? _c(
                                "li",
                                [
                                  _c("ProgressIndicatingButton.component", {
                                    attrs: {
                                      type: "dimmed",
                                      clickhandler: pivc.downloadContract,
                                      text: "Скачать контракт",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          pivc.isPurchaseAcceptingProposals &&
                          pivc.isSupplier &&
                          !pivc.isPurchaseSummarizing
                            ? _c(
                                "li",
                                [
                                  _vm.$store.getters.isLoggedIn
                                    ? _c("fl44-new-proposal-button", {
                                        attrs: {
                                          "notice-item":
                                            pivc.purchaseitem.plain,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                        ])
                      : _vm._e(),
                    _c("div", {
                      staticClass: "atmo-hash-jump-point",
                      attrs: { id: "atmo-bottom" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }